import { atom } from 'jotai';

import type { PickupPoint } from '@getjust/gateway';

// Stores the pickup point the user last manually selected, so segment
// switches (Pickup → Home → Pickup) don't lose their choice. The cart's
// `selected[0].pickupPoint` is cleared by the backend when the shipping
// method changes, so we re-apply this client-side via `useAutoSelectPickupPoint`
// — prefer this stored point over the closest one (`data[0]`) when re-entering
// pickup mode, provided it still exists in the current results list (matched
// by id). Falls back to `data[0]` otherwise.
//
// Session-scoped: jotai's default atom resets on page reload, which is the
// right scope — pickup-point IDs are not persisted across cart sessions.
export const lastUserPickupPointAtom = atom<PickupPoint | null>(null);
